import React, { Fragment } from "react";

// Interfaces
import { FormBuilderFieldProps } from "../../types";

// Components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IonButton, IonItem, IonLabel, IonNote } from "@ionic/react";
import { withTranslation } from "react-i18next";
import InputFactory from "../../components/Factories/Input/InputFactory";
import RulesSelector from "./RulesSelector";

const types = {
  text: "Text",
  email: "Email",
  password: "Password",
  phone: "Phone",
  select: "Select",
  checkbox: "Checkbox",
  radio: "Radio",
  radiogroup: "Radio Group",
  date: "Date",
  address: "Address",
  file: "File",
  image: "Image",
  pandadoc: "Pandadoc",
  sponsors: "Sponsors",
};

class FormBuilderField extends React.Component<FormBuilderFieldProps, any> {
  render() {
    const { question, t } = this.props;

    return (
      question && (
        <div className="form-list__form__item">
          <div style={{ display: "flex" }}>
            <IonItem class="w--50">
              <IonLabel position="stacked">{t("label")}</IonLabel>
              <InputFactory name="name" value={question.name} type={"text"} placeholder={t("fieldDisplayName")} onIonChange={(e: CustomEvent) => this.props.handleChange?.(e, question)} />
            </IonItem>
            <IonItem class="w--50">
              <IonLabel position="stacked">{t("key")}</IonLabel>
              <InputFactory name="key" value={question.key} type={"text"} placeholder={t("inputElementName")} onIonChange={(e: CustomEvent) => this.props.handleChange?.(e, question)} />
            </IonItem>
            <IonItem class="w--50">
              <IonLabel position="stacked">{t("scope")}</IonLabel>
              <InputFactory name="scope" value={question.scope} type={"text"} placeholder={t("scope")} onIonChange={(e: CustomEvent) => this.props.handleChange?.(e, question)} />
            </IonItem>
            <div className="ion-padding-vertical ion-padding-start">
              <IonButton fill="clear" size="small" onClick={(e: React.MouseEvent) => this.props.handleDelete?.(e, question)}>
                <FontAwesomeIcon icon={["far", "trash"]} />
              </IonButton>
            </div>
          </div>
          <IonItem>
            <IonLabel position="stacked">{t("type")}</IonLabel>
            <InputFactory name="type" type={"select"} value={question.type} options={types} onIonChange={(e: CustomEvent) => this.props.handleChange?.(e, question)} />
          </IonItem>
          {["select", "radiogroup"].includes(question.type) && (
            <Fragment>
              <IonItem>
                <IonLabel position="stacked">{t("optionsFrom")}</IonLabel>
                <InputFactory
                  name="optionsFrom"
                  value={question.optionsFrom}
                  type="text"
                  placeholder={t("ApiEndpointThatReturnsJsonArray")}
                  onIonChange={(e: CustomEvent) => this.props.handleChange?.(e, question)}
                />
              </IonItem>
              <IonItem>
                <IonLabel position="stacked">{t("options")}</IonLabel>
                <InputFactory
                  name="options"
                  type="json"
                  placeholder={t("jsonObjectOfKeyValuePairs")}
                  value={typeof question.options === "object" ? JSON.stringify(question.options) : question.options}
                  onIonChange={(e: CustomEvent) => this.props.handleChange?.(e, question)}
                />
              </IonItem>
            </Fragment>
          )}
          <IonItem>
            <IonLabel position="stacked">{t("attributes")}</IonLabel>
            <InputFactory
              name="attributes"
              type="json"
              placeholder={t("jsonObjectOfKeyValuePairs")}
              value={typeof question.attr === "object" ? JSON.stringify(question.attr) : question.attr}
              onIonChange={(e: CustomEvent) => this.props.handleChange?.(e, question)}
            />
          </IonItem>
          <IonItem style={{ overflow: "visible" }}>
            <IonLabel position="stacked">{t("rules")}</IonLabel>
            <RulesSelector
              name="rules"
              selected={Array.isArray(question.rules) ? question.rules.map((rule: string) => (rule.indexOf(":") > 0 ? rule.substr(0, rule.indexOf(":")) : rule)) : []}
              onToggle={(e: CustomEvent) => this.props.handleChange?.(e, question)}
            />
          </IonItem>
          <IonNote>
            {t("see")}{" "}
            <a href="https://laravel.com/docs/8.x/validation#available-validation-rules" target="_blank" rel="noopener noreferrer">
              {t("laravelValidationRules")}
            </a>{" "}
            {t("forMoreInformation")}.
          </IonNote>
        </div>
      )
    );
  }
}

export default withTranslation()(FormBuilderField);
